import React, { useState, useContext } from 'react';
import { FiEdit } from 'react-icons/fi';
import { useIntl } from 'react-intl';

import { useStateFromProp } from '~hooks/common';
import { UserContext } from '~contexts/user';

import Modal from '~components/modal';
import Photo from './photo';

import PersonalDataForm from './form';

const PersonalDataModal = ({ isOpened, onToggle = () => {} }) => {
  const intl = useIntl();

  const [isModalOpened, setModalOpen] = useStateFromProp(isOpened, onToggle);

  return (
    <Modal.Wrapper isOpened={isModalOpened} onClose={onToggle} className="c-modal--plain c-modal--narrow">
      <Modal.Content>
        <h2 className="l-headline--secondary c-modal__headline">
          {intl.formatMessage({
            id: 'containers.account.personal-data.modal.headline',
            defaultMessage: 'Personal details',
          })}
        </h2>
        <PersonalDataForm onSubmit={() => setModalOpen(false)} />
      </Modal.Content>
    </Modal.Wrapper>
  );
};

const PersonalData = () => {
  const intl = useIntl();

  const { user } = useContext(UserContext);
  const { accountType, firstName, operations, wish } = user;

  const personalNote = accountType === 'worker' ? operations?.personalNote : wish?.personalNote;

  const [isModalOpened, setIsModalOpened] = useState(false);

  return (
    <div className="c-box">
      <Photo />
      <div className="c-box__content">
        <div className="c-editable l-mb2">
          <div className="c-editable__content">
            <h3 className="l-headline--tertiary c-box__headline">
              {intl.formatMessage({
                id: 'containers.account.personal-data.headline',
                defaultMessage: 'Personal details',
              })}
            </h3>
          </div>
          <button type="button" className="c-editable__button" data-cy="c-personal-data-editable__button" aria-label={intl.formatMessage({ id: 'common.edit', defaultMessage: 'Edit' })} onClick={() => setIsModalOpened(true)}>
            <FiEdit aria-hidden="true" />
          </button>
        </div>

        <div className="c-group">
          <div className="c-group__label">
            {intl.formatMessage({ id: 'containers.account.personal-data.name', defaultMessage: 'Name' })}
          </div>
          <div className="c-group__value notranslate">{firstName || '-'}</div>
        </div>
        {/* PERSONAL NOTE */}
        <div className="c-group">
          <div className="c-group__label">
            {intl.formatMessage({ id: 'containers.account.personal-data.note', defaultMessage: 'About you' })}
          </div>
          <div className="c-group__value">{personalNote || '-'}</div>
        </div>
      </div>
      <PersonalDataModal isOpened={isModalOpened} onToggle={() => setIsModalOpened(false)} />
    </div>
  );
};

export default PersonalData;
